import type { NodeType } from "@tiptap/pm/model";
import { getAttributes } from "@tiptap/core";
import { Plugin, PluginKey } from "@tiptap/pm/state";
import { Keys } from "ls/common/lib/keyboard";

export interface EnterKeyHandlerOptions {
  type: NodeType;
  getUrl: (attrs: Record<string, unknown>) => string | undefined;
}

export function enterKeyHandler(options: EnterKeyHandlerOptions) {
  return new Plugin({
    key: new PluginKey("enterKeyHandler"),
    props: {
      handleKeyDown: (view, event) => {
        if (event.code !== Keys.Enter) {
          return false;
        }

        const attrs = getAttributes(view.state, options.type.name);
        if (!attrs) return false;

        const url = options.getUrl(attrs);
        if (!url) return false;

        window.open(url, "_blank", "noopener,noreferrer");
        return true;
      },
    },
  });
}
